import { FC, ReactNode } from 'react'
import { VenueTagAvatar, VenueTagAvatarType } from './Avatar'

const VenueTag: FC & VenueTagAvatarType = (): ReactNode => <></>

VenueTag.Avatar = VenueTagAvatar

export default VenueTag
